import React from "react";
import Header from "@/components/honex/Header";
import Hero from "@/components/honex/Hero";
import Marquee from "@/components/honex/Marquee";
import Leistungen from "@/components/honex/Leistungen";
import UeberUns from "@/components/honex/UeberUns";
import Prozess from "@/components/honex/Prozess";
import Kontakt from "@/components/honex/Kontakt";
import Footer from "@/components/honex/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white text-zinc-900">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Leistungen />
        <UeberUns />
        <Prozess />
        <Kontakt />
      </main>
      <Footer />
    </div>
  );
}
